/**
 * Configuration for mood image packages and labels
 *
 * Each package contains 4 images in order: [Anxiety, Flow, Apathy, Confident]
 * Add new packages here as they become available.
 */

// Base mood labels (English)
export const baseLabels = ["Anxiety", "Flow", "Apathy", "Confident"];

// Mood synonym translation keys structure
// Maps each base mood to an array of translation keys for its synonyms
export const moodSynonymKeys = {
  Anxiety: [
    "Stressed",
    /*
    "getMoodNames.anxious",
    "getMoodNames.worry",
    "getMoodNames.tension",
       */
  ],
  Flow: ["Flow"],
  Apathy: [
    "Apathetic",
    /*
    "getMoodNames.apathy",
    "getMoodNames.tired",
    "getMoodNames.burnedOut",

       */
  ],
  Confident: ["Calm"],
};

export const moodGenitiveKeys = [
  "Stress",
  "In flow",
  "Apathetic456",
  "Calm",
  /*
    "homepage.anxiety",
  "homepage.flow",
  "homepage.apathy",
  "homepage.comfort",
   */
];

export const buildMoodSynonyms = (t) => {
  const getMoodName = (key) => {
    const translation = t(key);
    return translation === key ? key.split(".").pop() : translation;
  };

  const synonyms = {};
  for (const [baseMood, keys] of Object.entries(moodSynonymKeys)) {
    synonyms[baseMood] = keys.map((key) => getMoodName(key));
  }
  return synonyms;
};

export const buildMoodGenitiveLabels = (t) => {
  return moodGenitiveKeys.map((key) => t(key));
};
